// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".generate-history ul li{\r\n    border: 1px solid #264d8e;\r\n    padding: 8px;\r\n    background: #ffedd5;\r\n    color: #4b5289;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    margin-bottom: 10px;\r\n}\r\n.generate-history ul li:hover,\r\n.generate-history ul li.active{\r\n    background: #fcc680;\r\n}\r\n\r\n.bg-my{\r\n    background-color: #fff9e1;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
